export enum TreeActionEnum {
  UNFOLD_ALL = "UNFOLD_ALL", // 展开全部
  FOLD_ALL = "FOLD_ALL", // 收起全部
  CHECK_ALL = "CHECK_ALL", // 全部勾选
  UNCHECK_ALL = "UNCHECK_ALL", // 取消全选
}
